module.exports = __webpack_public_path__ + "static/img/10015 (4).6c969c6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10015 (4).webp
// module id = iGQv
// module chunks = 14